import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import styles from './index.module.scss'

function Heatmap ({ heatMapData, hauler }) {
  useEffect(() => {
    const heatMapDataPoints = heatMapData.map(point => ({
      location: new google.maps.LatLng(point.lat, point.lng),
      weight: point.weight
    })) || []

    const mapInstance = new google.maps.Map(document.getElementById('heatmap'), {
      zoom: 10,
      center: { lat: hauler.lat, lng: hauler.lng },
      styles: [
        {
          elementType: 'geometry',
          stylers: [{ saturation: -100 }]
        }
      ]
    })
    const heatmap = new google.maps.visualization.HeatmapLayer({
      data: heatMapDataPoints,
      radius: 15,
      opacity: 0.85
    })
    heatmap.setMap(mapInstance)
  }, [heatMapData, hauler])

  return (
    <div className={styles.heatMap}>
      <div id='heatmap' className={styles.heatMapContainer} />
    </div>
  )
}

Heatmap.propTypes = {
  heatMapData: PropTypes.arrayOf(PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
    weight: PropTypes.number.isRequired
  })).isRequired,
  hauler: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired
  })
}

export default Heatmap
